import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseDialogModel } from './base-dialog.model';

@Component({
  selector: 'app-base-dialog',
  templateUrl: './base-dialog.component.html',
  styleUrls: ['./base-dialog.component.scss']
})
export class BaseDialogComponent {
  title: string;
  description: string;
  showCloseInHeader: boolean;
  cancelButtonText: string;
  confirmButtonText: string;

  constructor(
    public dialogRef: MatDialogRef<BaseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: BaseDialogModel,
  ) {}

  ngOnInit(): void {
    this.title = this.data.title || 'Title';
    this.description = this.data.bodyText || 'Description';
    this.showCloseInHeader = this.data.showCloseInHeader ?? false;
    this.cancelButtonText = this.data.cancelButtonText || 'Cancel';
    this.confirmButtonText = this.data.confirmButtonText || 'Confirm';
  }

  /**
   * This method is called when the confirm button is clicked.
   * It can be used to perform any action before closing the dialog.
   * For example, we can pass data back to the calling component.
   */
  onConfirm(): void {
    this.dialogRef.close({ confirmed: true });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
